import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

// Renders owner-approved legal content. block = string (paragraph) | array of strings (bullet list) | {sub:"..."}.
export default function LegalLayout({ title, description, effective, updated, sections }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useSeo({ title: `${title} | Inforno Travel`, description });
  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <header className="pt-36 md:pt-44 pb-12 px-6 md:px-12 border-b border-white/10">
        <div className="max-w-[820px] mx-auto">
          <p className="font-body text-[11px] uppercase tracking-[0.4em] text-gold mb-5">Legal</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light tracking-tight leading-[0.98]">{title}</h1>
          <p className="font-body text-white/40 text-sm mt-6">Effective Date: {effective} &nbsp;·&nbsp; Last Updated: {updated}</p>
        </div>
      </header>

      <main className="py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-[820px] mx-auto space-y-12">
          {sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              {s.h && <h2 className="font-serif text-2xl md:text-3xl font-light text-gold mb-5">{s.h}</h2>}
              <div className="space-y-4">
                {s.blocks.map((b, j) => {
                  if (Array.isArray(b)) return (
                    <ul key={j} className="space-y-2 pl-5">
                      {b.map((li, k) => <li key={k} className="font-body text-white/70 text-[15px] md:text-base leading-relaxed font-light list-disc marker:text-gold/60">{li}</li>)}
                    </ul>
                  );
                  if (b && typeof b === "object" && !Array.isArray(b) && b.sub) return <h3 key={j} className="font-body text-[13px] uppercase tracking-[0.15em] text-white/90 pt-2">{b.sub}</h3>;
                  return <p key={j} className="font-body text-white/70 text-[15px] md:text-base leading-[1.8] font-light">{b}</p>;
                })}
              </div>
            </section>
          ))}
        </div>
      </main>

      <div className="pb-24 px-6 md:px-12">
        <div className="max-w-[820px] mx-auto flex gap-6 text-sm">
          <Link to="/privacy" className="text-gold link-underline">Privacy Policy</Link>
          <Link to="/terms" className="text-gold link-underline">Terms of Use</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
